import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import MuiBreadcrumbs from '@material-ui/core/Breadcrumbs'
import { withStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'


const styles = () => ({
  root: {
    flex: 1,
  },
})


const Breadcrumbs = ({
  data,
  classes,
  className,
}) => (
  <Grid
    container
    wrap="nowrap"
    alignItems="center"
    justify="space-between"
  >
    <MuiBreadcrumbs
      className={classNames(classes.root, className)}
    >
      {data.map((item) => {
        let label = item
        let to = null

        if (typeof item === 'object') {
          label = item.label
          to = item.to
        }

        return (
          <Typography
            to={to}
            key={label}
            component={to ? Link : 'p'}
            color={to ? 'primary' : 'initial'}
            className={classNames({ pointer: !!to })}
          >
            {label}
          </Typography>
        )
      })}
    </MuiBreadcrumbs>
  </Grid>
)


Breadcrumbs.defaultProps = {
  data: [],
}


Breadcrumbs.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  data: PropTypes.arrayOf(PropTypes.any),
}


export default withStyles(styles)(Breadcrumbs)
